import axios from 'axios'
import {Message,Notification} from 'element-ui'
import store from '@/store'
import router from '@/router'
const apiUrl = window.API_URL;
// create an axios instance
const service = axios.create({
    baseURL: apiUrl,//process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        if (store.getters['user/token']) {
            config.headers['Authorization'] = store.getters['user/token'] || ''
        }
        if (store.getters['user/ssoToken']) {
            config.headers['Sso-Token'] = store.getters['user/ssoToken']
        }
        if (store.getters['user/systemType']) {
            config.headers['System-Type'] = store.getters['user/systemType']
        }
        // config.baseURL = process.env.VUE_APP_BASE_API;
        return config
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        if (res.code !== 0) {
            if(res.code === 401){
                store.dispatch('user/clearToken');
                router.push({path: '/notification?t=error'});
                return;
            }
            Notification({
                title:'提示',
                message: res.msg || 'Error',
                type: 'error',
            })
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        Notification({
            title:'提示',
            message: error.message || '系统异常，请稍后重试',
            type: 'error',
        })
        return Promise.reject(error)
    }
)

export default service
